// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.unsuitable-modal .sk-modal__wrapper .sk-modal__title {\n  padding-top: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
